import React from "react";
import { Box, Typography, usePagination } from "@mui/material";
import PaginationItem from "@mui/material/PaginationItem";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { getUserType } from "./common";
import PaginationSelect from "../components/select/pagination";
const CustomPagination = ({ count, onChange, siblingCount, boundaryCount, currentPage ,handleChangePerPage,limit,listingCount=0,totalCount=0}) => {
  const { items } = usePagination({
    count,
    page: currentPage + 1,
    siblingCount,
    boundaryCount,
    onChange,
  });
  return (
    <Stack direction="row" spacing={1} sx={{ width: "100%", justifyContent: "space-between", alignItems: "center", border: '0px solid red', padding: '10px', }}>
      {getUserType() === "admin" ?<Stack direction="row" justifyItems="flex-start" gap={0}><Box className="d-flex align-items-center rowPerPage" gap={0}>
                  <span style={{ width: '100%', height: '100%', color: 'black !important', display: 'flex', fontSize: {sm:'14px',xs:'0'}, fontWeight: '600', justifyContent: 'center', alignItems: 'center' }}>Rows per page:</span>
                  <PaginationSelect handleChange={handleChangePerPage} page={limit} />
                </Box>
                       <Typography variant="subtitle2" sx={{color:'#AAAAAA'}}>
                                {listingCount > 0
                                    ? currentPage === 0
                                        ? `0 - ${listingCount}`
                                        : `${limit * (currentPage - 0) + 1}  - ${limit * (currentPage - 0) + listingCount
                                        } `
                                    : "0 - 0"}{" "}
                                &nbsp;of {totalCount} items
                            </Typography>
      </Stack> : <Button
        sx={{ padding: '0px !important', width: {sm:'115px',xs:'36px'}, height: '36px', border: '1px solid #CCCBCB', borderRadius: '8px', "&:hover": { border: '1px solid var(--color-blue) !important', background: '#DBECFF', "& p": { color: 'var(--color-blue) !important' }, "& path": { fill: "var(--color-blue) !important" } }, "&.Mui-disabled": { "& p": { color: 'var(--btnBorder) !important' }, "& path": { fill: "var(--btnBorder) !important" } } }}
        disabled={currentPage === 0}
        onClick={() => onChange(currentPage)}
      >
        <Typography sx={{ width: '100%', height: '100%', color: 'black !important', display: 'flex', fontSize: {sm:'14px',xs:'0'}, fontWeight: '600', justifyContent: 'center', alignItems: 'center', "& path": { fill: "black !important" } }}>

          <ArrowForwardIcon sx={{ height: '20px !important', width: '20px !important', rotate: '180deg' }} /> &nbsp;Previous
        </Typography>
      </Button>}
      <Box>

        {items?.filter((item) => (item.type !== 'next' && item.type !== 'previous')).map(({ page, type, selected, ...item }, index) => {
          if (type === "start-ellipsis" || type === "end-ellipsis") {
            return <span key={index}>...</span>;
          }
          if (page < 1 || page > count) return null;
          return (
            <PaginationItem
              key={index}
              {...item}
              page={page}
              sx={{
                height: '40px !important', width: '40px !important', borderRadius: '8px', background: '#fff !important', "&:hover": { background: '#DBECFF !important', color: 'var(--color-blue)' }
                , "&.Mui-selected": { background: '#DBECFF !important', color: 'var(--color-blue)' }
              }}
              selected={selected}
              onClick={() => onChange(page)}
            />
          );
        })}
      </Box>

   {getUserType()==="admin" ? <>
   <Stack direction="row" justifyItems="flex-end" gap={2}>
    <Button
        sx={{ padding: '0px !important', width: {sm:'115px',xs:'36px'}, height: '36px', border: '1px solid #CCCBCB', borderRadius: '8px', "&:hover": { border: '1px solid var(--color-blue) !important', background: '#DBECFF', "& p": { color: 'var(--color-blue) !important' }, "& path": { fill: "var(--color-blue) !important" } }, "&.Mui-disabled": { "& p": { color: 'var(--btnBorder) !important' }, "& path": { fill: "var(--btnBorder) !important" } } }}
        disabled={currentPage === 0}
        onClick={() => onChange(currentPage)}
      >
        <Typography sx={{ width: '100%', height: '100%', color: 'black !important', display: 'flex', fontSize: {sm:'14px',xs:'0'}, fontWeight: '600', justifyContent: 'center', alignItems: 'center', "& path": { fill: "black !important" } }}>

          <ArrowForwardIcon sx={{ height: '20px !important', width: '20px !important', rotate: '180deg' }} /> &nbsp;Previous
        </Typography>
      </Button>
    <Button
        sx={{ padding: '0px !important', width:{sm:'115px',xs:'36px'}, height: '36px', border: '1px solid #CCCBCB', borderRadius: '8px', "&:hover": { border: '1px solid var(--color-blue) !important', background: '#DBECFF', "& p": { color: 'var(--color-blue) !important' }, "& path": { fill: "var(--color-blue) !important" } }, "&.Mui-disabled": { "& p": { color: 'var(--btnBorder) !important' }, "& path": { fill: "var(--btnBorder) !important" } } }}
        disabled={currentPage + 1 === count}
        onClick={() => onChange(currentPage + 2)}
      >
        <Typography sx={{ width: '100%', height: '100%', color: 'black !important', display: 'flex', fontSize: {sm:'14px',xs:'0'}, fontWeight: '600', justifyContent: 'center', alignItems: 'center', "& path": { fill: "black !important" } }}>

          Next &nbsp; <ArrowForwardIcon sx={{ height: '20px !important', width: '20px !important', padding: 0, margin: 0 }} />
        </Typography>
      </Button>
   </Stack>
   </> :   <Button
        sx={{ padding: '0px !important', width:{sm:'115px',xs:'36px'}, height: '36px', border: '1px solid #CCCBCB', borderRadius: '8px', "&:hover": { border: '1px solid var(--color-blue) !important', background: '#DBECFF', "& p": { color: 'var(--color-blue) !important' }, "& path": { fill: "var(--color-blue) !important" } }, "&.Mui-disabled": { "& p": { color: 'var(--btnBorder) !important' }, "& path": { fill: "var(--btnBorder) !important" } } }}
        disabled={currentPage + 1 === count}
        onClick={() => onChange(currentPage + 2)}
      >
        <Typography sx={{ width: '100%', height: '100%', color: 'black !important', display: 'flex', fontSize: {sm:'14px',xs:'0'}, fontWeight: '600', justifyContent: 'center', alignItems: 'center', "& path": { fill: "black !important" } }}>

          Next &nbsp; <ArrowForwardIcon sx={{ height: '20px !important', width: '20px !important', padding: 0, margin: 0 }} />
        </Typography>
      </Button>}
    </Stack>

  );
};

export default CustomPagination;